
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-section').forEach((container) => {
    const button = container.querySelector('.video-section-play-button');
    const embedContainer = container.querySelector('.embed-video-container');

    if(!button) return;

    const stopVideo = () => {
      if(container.querySelector('video')){
        container.querySelector('video')?.pause();
        container.querySelector('video').currentTime = 0;
        if(button){
          button.classList.remove('hidden');
        }
      }else if(embedContainer.placeholderContent){
        embedContainer.innerHTML = embedContainer.placeholderContent;
        if(button){
          button.classList.remove('hidden');
        }
      }
    }

    container.stopVideo = stopVideo;

    button.addEventListener('click', (event) => {
      event.preventDefault();

      if(container.querySelector('video')){
        container.querySelector('video')?.play();
        button.classList.add('hidden');
      }else if(container.querySelector('.embed-video-container')?.dataset.source === 'youtube') {
        let video = '';
        video = '<iframe src="https://www.youtube.com/embed/';
        video += embedContainer.dataset.videoId + '?autoplay=1';
        video += '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" loading="lazy"></iframe>';
        
        embedContainer.placeholderContent = embedContainer.innerHTML;
        embedContainer.innerHTML = video;
        button.classList.add('hidden');
      }else if(container.querySelector('.embed-video-container')?.dataset.source === 'vimeo') {
        let video = '';
        video = '<iframe src="https://player.vimeo.com/video/';
        video += embedContainer.dataset.videoId;
        video += '?autoplay=1&byline=0&portrait=0&badge=0&dnt=true&vimeo_logo=false&title=false&color=FB4400';
        video += '"allow="autoplay; fullscreen; picture-in-picture" loading="lazy"></iframe>';

        embedContainer.placeholderContent = embedContainer.innerHTML;
        embedContainer.innerHTML = video;
        button.classList.add('hidden');
      }
    })
  });
});